import { render, staticRenderFns } from "./SquareCell.vue?vue&type=template&id=fa32b3f6&scoped=true&"
import script from "./SquareCell.vue?vue&type=script&lang=js&"
export * from "./SquareCell.vue?vue&type=script&lang=js&"
import style0 from "./SquareCell.vue?vue&type=style&index=0&id=fa32b3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa32b3f6",
  null
  
)

export default component.exports